export default __webpack_public_path__ + "static/media/21.79d698fb.svg";